<mat-dialog-content> <p> {{message}} </p> </mat-dialog-content> <br/>

<mat-dialog-actions>

		<button mat-raised-button class = "btn-success" (click)="onConfirmClick()"style = "margin-left:20%;"> {{confirmButtonText}} </button>

		<button mat-raised-button class = "btn-danger" (click) = "onRejectClick()"  style = "margin-left:30%; "> {{cancelButtonText}} </button>

</mat-dialog-actions>